// @flow
import React from 'react';
import Table from 'antd/lib/table/Table';
import notification from 'antd/lib/notification';

import Header from '../../../components/layout/Header';
import { Section } from '../../../components/layout';
import Filter from './components/Filter';
import { applyMaskToValue } from './../../../lib/helpers';
import type {
  ReportGpmOrder,
  ReportGpmOrderParams
} from '../../../lib/types/reportGpmOrder';
import { notificationLoading } from '../../../components/Notifications';
import { reportGpmOrderApi } from '../../../lib/api';
import { formatLicensePlateMask } from '../../../components/masked-inputs/LicensePlateInput';

const initialParams: ReportGpmOrderParams = {};

type State = {
  params: ReportGpmOrderParams,
  loading: boolean,
  data: ReportGpmOrder[]
};

/**
 * Отчет об учете заявок ГПМ
 */
export class GpmOrderList extends React.Component<{}, State> {
  state = {
    params: initialParams,
    loading: false,
    data: []
  };

  handleChangeFilter = (key: $Keys<any>, value: any) => {
    this.setState(prevState => ({
      params: {
        ...prevState.params,
        [(key: string)]: value
      }
    }));
  };

  async componentDidMount() {
    await this.fetchReportGpmOrders();
  }

  fetchReportGpmOrders = async () => {
    try {
      this.setState({ loading: true });
      const data = await reportGpmOrderApi.fetchReportGpmOrder(
        this.state.params
      );
      this.setState({ data });
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  applyParams = this.fetchReportGpmOrders;

  cleanParams = () => this.setState({ params: initialParams });

  handleExport = async () => {
    try {
      notificationLoading({
        message: 'Формирование файла для печати',
        key: 'print'
      });
      await reportGpmOrderApi.printReportGpmOrder(this.state.params);
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.close('print');
    }
  };

  columns = [
    {
      title: 'Дата',
      dataIndex: 'date'
    },
    {
      title: 'Номер записи',
      dataIndex: 'idNumber'
    },
    {
      title: 'Тип ТС',
      dataIndex: 'vehicleType',
      render: (type: string, record: ReportGpmOrder) =>
        type || record.vehicleGroup
    },
    {
      title: 'Госномер',
      dataIndex: 'licensePlate',
      render: (licensePlate: ?string) =>
        licensePlate && applyMaskToValue(licensePlate, formatLicensePlateMask)
    },
    {
      title: 'Номер заявки',
      dataIndex: 'orderId'
    },
    {
      title: 'Подразделение',
      dataIndex: 'orgUnitName'
    },
    {
      title: 'Объект, адрес',
      dataIndex: 'object'
    },
    {
      title: 'Заявитель',
      dataIndex: 'claimant'
    },
    {
      title: 'Примечание',
      dataIndex: 'notation',
      render: (value: string) => value || '-'
    }
  ];

  render() {
    const { data, loading } = this.state;
    return (
      <>
        <Header left={<h1>Отчет об учёте ГПМ</h1>} />
        <Section>
          <Filter
            params={this.state.params}
            onChangeFilter={this.handleChangeFilter}
            applyParams={this.applyParams}
            cleanParams={this.cleanParams}
            onExport={this.handleExport}
          />
          <Table
            loading={loading}
            pagination={false}
            dataSource={data}
            columns={this.columns}
          />
        </Section>
      </>
    );
  }
}

export default GpmOrderList;
